const Helper = class _Helper {

    static formatDate(str) {
        if (!str) return '';
        const date = new Date(str);
        return [
            String(date.getFullYear()),
            String(date.getMonth() + 1).padStart(2, '0'),
            String(date.getDate()).padStart(2, '0')
        ].join(' '); // Join year, month, and day with a space
    }

    static YmdToDmy(str) {
        if (!str) return '';

        const date = new Date(str);
        return [
            String(date.getDate()).padStart(2, '0'),
            String(date.getMonth() + 1).padStart(2, '0'),
            String(date.getFullYear()),
        ].join(' '); // Join year, month, and day with a space
    }

    static dmyToYmd(str) {
        if (!str) return '';

        const [dd, mm, yyyy] = str.split(' ').map(Number);
        //fix for "NaN-NaN-NaN"
        const date = new Date(yyyy, mm - 1, dd);
        return [
            String(date.getFullYear()),
            String(date.getMonth() + 1).padStart(2, '0'),
            String(date.getDate()).padStart(2, '0')
        ].join('-'); // Join year, month, and day with a space
    }

    static validateDate(dateString) {
        return /^\d{4} \d{2} \d{2}$/.test(dateString);  // Matches format 'yyyy mm dd'
    }

    static isValidPrice(value) {
        // Convert to number and check if it's finite and greater than or equal to zero
        const numberValue = Number(value);
        return Number.isFinite(numberValue) && numberValue > 0;
    }

    static getPageUrl({pageKey, endpointKey = '', args = {}}) {

        const pageSlug = ESR.options.slugs[pageKey];
        if (!pageSlug) {
            console.warn(`Slug not found for pageKey: ${pageKey}`);
            return '';
        }

        let url = `/${pageSlug}/`;
        if (endpointKey) {
            url += `${endpointKey}/`;
        }

        // Add query parameters if args is not empty
        if (Object.keys(args).length > 0) {
            const queryString = new URLSearchParams(args).toString();
            url += `?${queryString}`;
        }

        return window.location.origin + url;
    }

    static getAutoUrl(slug) {
        return this.getPageUrl({pageKey: 'auto'}) + slug + '/'
    }

    static getToolUrl(slug) {
        return this.getPageUrl({pageKey: 'tool'}) + slug + '/'
    }

    static getProjectUrl(slug) {
        return this.getPageUrl({pageKey: 'project'}) + slug + '/'
    }

    static getProjectReportUrl(slug) {
        return this.getPageUrl({pageKey: 'project'}) + slug + '/report/'
    }

    static getReportUrl(endpoint, args = {}) {
        return this.getPageUrl({pageKey: 'reports', endpointKey: endpoint, args})
    }

    static getReportWorkerUrl({id, project_id = 0}) {
        const args = {};

        if (project_id) {
            args.project_id = project_id;
        }

        return ESR.Helper.getPageUrl({pageKey: 'worker', endpointKey: id, args});
    }


    static getFleetServiceTypeById(id) {
        return ESR?.fleet_services[id] || null;
    }

    static getUserNameById(id) {
        if(!ESR?.users) return id;
        return ESR?.users[id]?.name || id;
    }

    static getPostAuthorID() {
        return ESR.post?.author_id ? parseInt(ESR.post.author_id) : 0
    }

    static getUserID() {
        return ESR.user?.id ? parseInt(ESR.user.id) : 0
    }


    static getUserRole() {
        return ESR.user?.role ?? ''
    }

    static canCreate() {
        return this.isManager() || this.isAdmin() || this.isSuperadmin()
    }

    static canEditOther() {
        return this.isAdmin() || this.isSuperadmin()
    }

    static userCan(capability) {
        return ESR?.user?.caps?.hasOwnProperty(capability) ? ESR.user.caps[capability] : false;
    }

    static isSuperadmin() {
        return this.getUserRole() === 'administrator'
    }

    static isAdmin() {
        return this.getUserRole() === 'admin'
    }

    static isManager() {
        return this.getUserRole() === 'manager'
    }

    static isWorker() {
        return this.getUserRole() === 'worker'
    }

    static isNotApproved() {
        return this.getUserRole() === 'subscriber'
    }

    static isPostAuthor() {
        return this.getUserID() === this.getPostAuthorID()
    }


    static select2DestroyAll(el) {
        el.find('select').each(function () {
            $(this).select2('destroy');
        });
    }

    static destroyDatepicker($input) {
        if ($input && $input.datepicker) {
            $input.datepicker('destroy');
        }
    }

    static validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email)
    }

    static validatePassword(password) {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
        return passwordRegex.test(password)
    }

    static toFloat(value) {
        const num = parseFloat(value);
        return isNaN(num) ? 0 : num;
    }


}

export default Helper;